import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[dtmUiMobileTable]" })
export class MobileTableDirective {
    constructor(public templateRef: TemplateRef<unknown>) {}
}
